import { Box, Grid, Typography, Stack } from "@mui/material";
import img from "./icon/GridbackImg.webp";
import img2 from "./icon/01.png";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
import ApiIcon from "@mui/icons-material/Api"; 
import WebhookIcon from "@mui/icons-material/Webhook";

const features = [
  {
    title: "Integration",
    icon: IntegrationInstructionsIcon, 
    description:
      "Discover a wide range of SDKs, pluginsand server integration options. Seamlessly integrate powerful tools for effortless workflows.",
  },
  {
    title: "API reference",
    icon: ApiIcon, 
    description:
      "Discover a wide range of SDKs, pluginsand server integration options. Seamlessly integrate powerful tools for effortless workflows.",
  },
  {
    title: "Webhook",
    icon: WebhookIcon, 
    description:
      "Discover a wide range of SDKs, pluginsand server integration options. Seamlessly integrate powerful tools for effortless workflows.",
  },
];

const GridSectionMobile = () => {
  return (
    <Stack
      sx={{
        background: `linear-gradient(90deg, #002e4d 0%, #0070c0 100%), url(${img})`,
        backgroundBlendMode: "overlay",
        zIndex: -1,
        color: "white",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <Box
        sx={{
          background: `linear-gradient(90deg,rgba(0, 46, 77, 0.75) 0%,rgba(0, 112, 192, 0.75) 100%)`,
          backgroundBlendMode: "overlay",
          py: { xs: 4, sm: 6, md: 8 },
          px: { xs: 1, sm: 2, md: 6 },
        }}
      >
        <Box
          sx={{
            maxWidth: 1400,
            display: "flex",
            flexDirection: "column",
            mx: "auto",
            width: "100%",
          }}
          padding={{ xs: 2, sm: 3, md: 4 }}
        >
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            mb={2}
            sx={{
              flexDirection: { xs: "row", sm: "row" },
              alignItems: { xs: "center", sm: "center" },
              textAlign: { xs: "inherit", sm: "inherit" },
            }}
          >
            <Box
              component="span"
              sx={{
                width: { xs: 3, sm: 5 },
                height: { xs: 24, sm: 40 },
                borderTopRightRadius: 20,
                borderBottomRightRadius: 20,
                backgroundColor: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: { xs: "20px", sm: "32px" },
                fontWeight: "bold",
                color: "#001f3f",
                mb: { xs: 1, sm: 0 },
              }}
            />
            <Typography
              variant="h4"
              fontWeight="bold"
              textAlign={{ xs: "left", sm: "left" }}
              sx={{
                color: "white",
                fontSize: { xs: "24px", sm: "32px", md: "40px" },
              }}
            >
              Engineered for{" "}
              <Box
                component="span"
                sx={{
                  color: "#D0FF00",
                  fontSize: { xs: "24px", sm: "32px", md: "40px" },
                }}
              >
                developers
              </Box>
            </Typography>
          </Stack>
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: { xs: "16px", sm: "20px", md: "24px" },
              textAlign: { xs: "left", sm: "left" },
            }}
          >
            Our advanced integrations consolidate business operations, making
            them smoother and efficient.
          </Typography>
          <Stack
            height={{ xs: 400, sm: 500, md: 600 }}
            width={{ xs: "100%", sm: "90%", md: "75%", lg: "55%" }}
            alignItems="center"
            my={{ xs: 2, sm: 4 }}
          >
            <Box
              component="img"
              src={img2}
              alt="Developer Section"
              sx={{
                // border: "1px solid white",
                width: { xs: "110%", sm: "90%", md: "75%", lg: "55%" },
                height: "100%",
                borderRadius: 2,
                objectFit: "contain",
                mb: { xs: 2, sm: 4 },
              }}
            />
          </Stack>

          <Grid
            container
            spacing={{ xs: 2, sm: 3, md: 4 }}
            justifyContent="center"
            mb={{ xs: 2, sm: 4 }}
          >
            {features.map((item, idx) => {
              const IconComponent = item.icon;
              return (
                <Grid item xs={12} sm={6} md={4} key={idx}>
                  <Stack
                    sx={{
                      height: { xs: "100%", sm: "100%", md: "100%" },
                      width: "100%",
                      display: "flex",
                      flexDirection: "row", 
                      justifyContent: "flex-start",
                      alignItems: "center",
                      background: "linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05))", // Glassmorphism effect
                      backdropFilter: "blur(10px)",
                      WebkitBackdropFilter: "blur(10px)",
                      borderRadius: "12px",
                      border: "1px solid rgba(255, 255, 255, 0.2)",
                      boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
                      padding: { xs: "0.75rem", sm: "1rem" },
                      gap: { xs: "0.75rem", sm: "1rem" },
                      transition: "all 0.3s ease",
                      "&:hover": {
                        background: "linear-gradient(135deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.1))",
                        boxShadow: "0px 6px 24px rgba(0, 0, 0, 0.2)",
                      },
                    }}
                  >
                    {/* Icon Section with Nested Glassmorphism */}
                    <Stack
                      sx={{
                        height: { xs: "50px", sm: "60px" },
                        width: { xs: "50px", sm: "60px" },
                        borderRadius: "8px",
                        border: "1px solid rgba(255, 255, 255, 0.15)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "linear-gradient(135deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.03))",
                        backdropFilter: "blur(6px)",
                        WebkitBackdropFilter: "blur(6px)",
                        boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      {IconComponent && (
                        <IconComponent
                          sx={{
                            fontSize: { xs: "32px", sm: "40px" },
                            color: "rgba(255, 255, 255, 0.9)",
                          }}
                        />
                      )}
                    </Stack>

                    {/* Title and Description */}
                    <Stack
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#fff",
                          fontSize: { xs: "14px", sm: "16px" },
                          fontWeight: "600",
                          fontFamily: "'Roboto', sans-serif",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                        }}
                      >
                        {item.title}
                      </Typography>
                      <Typography
                        sx={{
                          color: "rgba(255, 255, 255, 0.95)",
                          fontSize: { xs: "12px", sm: "14px" },
                          fontWeight: "400",
                          fontFamily: "'Roboto', sans-serif",
                        }}
                      >
                        {item.description}
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      </Box>
    </Stack>
  );
};

export default GridSectionMobile;